import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage, makeDataDangerous} from 'nutshell-core/utils/graphql-errors';

import type {
    GetAudienceDashboard_audienceDashboard as AudienceDashboard,
    GetAudienceDashboard as GetAudienceDashboardQuery,
    GetAudienceDashboardVariables as GetAudienceDashboardQueryVariables,
    DashboardInput,
} from 'nutshell-graphql-types';

import GET_AUDIENCE_DASHBOARD from '../queries/get-audience-dashboard.graphql';

export const useGetAudienceDashboard = (
    input: DashboardInput
): {
    isLoading: boolean;
    errorMessage: string | null | undefined;
    audienceDashboard: AudienceDashboard;
} => {
    const {loading, data, error} = useQuery<
        GetAudienceDashboardQuery,
        GetAudienceDashboardQueryVariables
    >(GET_AUDIENCE_DASHBOARD, {
        variables: {input},
        notifyOnNetworkStatusChange: true,
    });

    const {audienceDashboard} = makeDataDangerous(data);

    return {
        isLoading: loading,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
        audienceDashboard,
    };
};
